import React from 'react';
import { Box, Input, DropdownSingleSelect } from '@opendoor/bricks/core';

import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { LOCKBOX_LOCATION_OPTIONS } from 'sellDirect/helpers/closingDash/inputOptions';
import { CustomInputLabel } from 'sellDirect/components/closingDash/form/CustomInputLabel';

interface IProps {
  resetableForm: IResetableFormRenderProps;
}
const LOCKBOX_ID = 'key-lockbox-location';
/**
 * Label and input for lockbox location.
 *
 * storybook-check-ignore
 */
export const LockboxLocation: React.FC<IProps> = ({ resetableForm: { onUpdate, formState } }) => {
  return (
    <Box data-testid="lockbox-location">
      <CustomInputLabel
        id={LOCKBOX_ID}
        title="Key and lockbox location"
        subtitle="Please select where you have placed the key and lockbox"
        required={true}
        titleFontSize="s3"
        titleFontWeight="bold"
      />
      <Box data-testid="lockbox-input" mt={4}>
        <DropdownSingleSelect
          aria-labelledby={LOCKBOX_ID}
          name="lockboxLocation"
          autoComplete="off"
          onChange={(e) => {
            onUpdate('lockboxLocation', e);
          }}
          options={LOCKBOX_LOCATION_OPTIONS}
          selectedValue={[formState?.lockboxLocation]}
        />
      </Box>
      {formState.lockboxLocation === 'other' && (
        <Box mt={4}>
          <Input
            analyticsName="cake-closing-dash-lockbox-location"
            required
            id="lockboxLocationOther"
            type="text"
            name="lockboxLocationOther"
            aria-label="Key and Lockbox location"
            label="Describe where"
            value={formState?.lockboxLocationOther}
            onChange={(_event, value) => onUpdate('lockboxLocationOther', value)}
            unboundedWidth
            placeholder="Location of lockbox"
          />
        </Box>
      )}
    </Box>
  );
};
